import {Injectable} from '@angular/core';
import {DataService} from './data.service';

@Injectable({
  providedIn: 'root'
})
export class ImgUrlCreationService {

  constructor() {
  }

  public static createImgUrl(id, specs) {
    return DataService.API_URL + 'images/' + id + '/thumb/' + specs;
  }
}
